import React from "react";
import { useState, useEffect } from "react";

import LoginDialog from "./LoginDialog";
import RegisterOrResetDialog from "./RegisterOrResetDialog";
import AuthPageOptionType from "../PageTypes/AuthPageOptionType";
import { useNavigate } from "react-router-dom";

import PersonalizationConfig from "../PersonalizationComponents/PersonalizationConfig";

import Page from "../PageComponents/Page";

import { useSearchParams } from "react-router-dom";
import { isMobile } from "react-device-detect";

const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,10}$/;

type AuthPageProps = {
  pageLoading: boolean;
  registrationEnabled: boolean;
  openAuthDialog: AuthPageOptionType;
  setUserFullName: (newUserFullName: string | undefined) => void;
  setUserConfig: (newConfig: PersonalizationConfig) => void;
  setEmailVerified: (newEmailVerified: boolean) => void;
};

function AuthPage(props: AuthPageProps) {
  const [searchParams, setSearchParams] = useSearchParams();
  const searchParamEmail = searchParams.get("email")?.toLowerCase();
  const searchParamEmailValid =
    searchParamEmail !== null && searchParamEmail !== undefined && emailRegex.test(searchParamEmail);

  if (searchParamEmailValid && isMobile) {
    window.location.replace("https://usesalus.com/?redirectedFrom=mobileRegistration");
  }

  const registrationEnabled = props.registrationEnabled;

  const [email, setEmail] = useState(searchParamEmailValid && !isMobile ? searchParamEmail : "");
  const [emailUnsubmitted, setEmailUnsubmitted] = useState(
    searchParamEmailValid && !isMobile && registrationEnabled ? false : true
  );

  const [username, setUsername] = useState(searchParamEmailValid ? searchParamEmail : "");

  useEffect(() => {
    setSearchParams((oldParams) => {
      oldParams.delete("email");
      return oldParams;
    });
  }, [setSearchParams]);

  useEffect(() => {
    if (!emailUnsubmitted && isMobile) {
      if (registrationEnabled) {
        window.location.replace("https://usesalus.com/?redirectedFrom=mobileRegistration");
      } else {
        window.location.replace("https://usesalus.com/?redirectedFrom=registrationDisabled");
      }
    }
  }, [emailUnsubmitted, registrationEnabled]);

  const navigate = useNavigate();

  return (
    <Page pageLoading={props.pageLoading} noFooter={props.openAuthDialog === "register"}>
      {props.openAuthDialog === "register" || props.openAuthDialog === "reset" ? (
        <RegisterOrResetDialog
          isReset={props.openAuthDialog === "reset"}
          openLoginDialog={() => navigate("/login")}
          openRegisterDialog={() => navigate("/register")}
          setUserFullName={props.setUserFullName}
          setUserConfig={props.setUserConfig}
          username={username}
          setUsername={setUsername}
          email={email}
          setEmail={setEmail}
          emailUnsubmitted={emailUnsubmitted}
          setEmailUnsubmitted={setEmailUnsubmitted}
          setEmailVerified={props.setEmailVerified}
          registrationEnabled={registrationEnabled}
        />
      ) : (
        <LoginDialog
          openRegisterDialog={() => navigate("/register")}
          openResetDialog={() => navigate("/reset")}
          setUserFullName={props.setUserFullName}
          setUserConfig={props.setUserConfig}
          username={username}
          setUsername={setUsername}
        />
      )}
    </Page>
  );
}

export default AuthPage;
